import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Eingabemodus: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BulmaButton = _resolveComponent("BulmaButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_BulmaButton, _mergeProps(_ctx.$attrs, {
      icon: 
      'fa-solid fa-' +
      (_ctx.store.is_touch_device ? 'hand-pointer' : 'arrow-pointer')
    ,
      text: _ctx.store.is_touch_device ? 'Touch' : 'Desktop',
      onClick: _withModifiers(_ctx.store.toggle_touch_device, ["left"])
    }), null, 16, ["icon", "text", "onClick"])
  ], 64))
}